// @ts-nocheck
import {
  getConfigForDepositEstimates,
  getEstimateHistoryforDropdown,
} from "../../../utils/methods/estimate/estimateMethods";
import {
  FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST,
  FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE,
  FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS,
  SWITCH_DEPOSIT_INVOICE,
  FETCH_ALL_DEPOSIT_INVOCIE_REQUEST,
  FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS,
  FETCH_ALL_DEPOSIT_INVOCIE_FAILURE,
  CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST,
  CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS,
  DEPOSIT_INVOICE_PO_NUMBER_SUCCESS,
  CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE,
} from "../../constants/depositInvoice/depositInvoice";

const initialState = {
  currentEstimate: {},
  allEstimates: [],
  estimateHistoryDropdown: [],
  allEstimatesHistory: [],
  isLoading: false,
  statusLoading: false,
};

export const depositInvoiceReducer = (state = initialState, action) => {
  switch (action?.type) {
    // fetch submitted estimates
    case FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS: {
      const newAllEstimates = getConfigForDepositEstimates({
        configs: action?.payload,
      });
      const estimateList = getEstimateHistoryforDropdown({
        configs: action?.payload,
      });
      return {
        ...state,
        currentEstimate: newAllEstimates?.[estimateList?.[0]?.value],
        isLoading: false,
        allEstimates: newAllEstimates,
        estimateHistoryDropdown: estimateList,
      };
    }

    case FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // case switch estimate
    case SWITCH_DEPOSIT_INVOICE: {
      const foundEstimate = state?.allEstimates?.[action?.payload];
      return {
        ...state,
        currentEstimate: foundEstimate,
      };
    }

    // fetch deposit invoice history
    case FETCH_ALL_DEPOSIT_INVOCIE_REQUEST:
      return {
        ...state,
        historyLoading: true,
      };

    case FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        allEstimatesHistory: action?.payload,
      };

    case FETCH_ALL_DEPOSIT_INVOCIE_FAILURE:
      return {
        ...state,
        historyLoading: false,
      };

    // udpate deposit invoice client status
    case CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST:
      return {
        ...state,
        statusLoading: true,
      };

    case CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        allEstimatesHistory: state?.allEstimatesHistory?.map((item) => {
          if (item?._id === action?.payload) {
            return {
              ...item,
              status: item?.status === "sent" ? "received" : "sent",
            };
          } else return item;
        }),
      };

    case DEPOSIT_INVOICE_PO_NUMBER_SUCCESS:
      return {
        ...state,
        allEstimatesHistory: state?.allEstimatesHistory?.map((item) =>
          item?._id === action?.payload?.depositInvoiceId
            ? { ...item, PONumber: action?.payload?.PONumber }
            : item,
        ),
      };

    case CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE:
      return {
        ...state,
        statusLoading: false,
      };

    // default case
    default:
      return state;
  }
};

export default depositInvoiceReducer;
export { initialState };